import styled from 'styled-components';
import { link } from 'styles/theme';

export const Hyperlink = styled.a`
    color: ${link};
    text-decoration: none;
`;
